import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { BaseQueryParams } from 'types/base-query-params';
import { PaginatedResponse } from 'types/dtos';
import { constructQueryParams } from 'utils/query-params-builder';
import { ResponseAccountDto } from '../types/dtos';

export type AccountsQueryParams = BaseQueryParams & {
    role_id?: string;
    email?: string;
};

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.query<PaginatedResponse<ResponseAccountDto>, AccountsQueryParams>({
        async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
            const accountsResponse = await fetchWithBQ(constructQueryParams(APP_ENDPOINTS.ACCOUNTS, _arg));

            if (accountsResponse.error) {
                return { error: accountsResponse.error };
            }

            const accounts = accountsResponse.data as PaginatedResponse<ResponseAccountDto>;

            return {
                data: accounts,
            };
        },
    });
